module.exports = __webpack_public_path__ + "static/media/earth-cropped.c1009782.png";